export { easeIn, easeInOut, easeOut, linear } from '../utils/curves';
export type { AnimationCurve } from '../utils/curves';
